import PropTypes from 'prop-types';

import LeadGenForm from '../get-in-touch-components/lead-gen-form.component';

import { parseTitle } from '../../../utils/title-parser';

const ContactForm = (props) => {
    
    const {
        title,
        paragraph,
        campaignName,
        formRoomTypeCategoriesData,
        formFurnishingOptionsData,
        campaignData
    } = props;    

    const renderFormSection = () => {
        return (
            <LeadGenForm
                formRoomTypeCategoriesData={formRoomTypeCategoriesData}
                formFurnishingOptionsData={formFurnishingOptionsData}
                campaignData={campaignData}
                campaignName={campaignName}
            />
        );
    };

    const renderTextSection = () => {
        return (
            <div>
                {parseTitle(title, 'contact-form-section-title')}
                <p className='contact-form-section-paragraph'>{paragraph}</p>
            </div>
        );
    };

    return (

        <div className='container-root container-root-maxWidthLg'>

            <div className='main-grid-container main-grid-spacing-xs-3 contact-form-section-grid'>

                <div className='main-grid-item main-grid-md-6'>

                    {renderTextSection()}

                </div>

                <div className='main-grid-item contact-form-section-grid-item main-grid-md-5'>

                    {renderFormSection()}

                </div>

            </div>

        </div>

    );
};

export default ContactForm;

ContactForm.propTypes = {
    campaignName: PropTypes.string,
    title: PropTypes.string,
    paragraph: PropTypes.string,
    formRoomTypeCategoriesData: PropTypes.array,
    formFurnishingOptionsData: PropTypes.array,
    campaignData: PropTypes.object,
};
